import { render, staticRenderFns } from "./LastNews.vue?vue&type=template&id=11399e99&scoped=true"
import script from "./LastNews.vue?vue&type=script&lang=ts"
export * from "./LastNews.vue?vue&type=script&lang=ts"
import style0 from "./LastNews.vue?vue&type=style&index=0&id=11399e99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11399e99",
  null
  
)

export default component.exports